import React from 'react';
// scss
import 'components/Form/Input.scss';

const Input = ({
  className = '',
  type = 'text',
  name = '',
  placeholder,
  autoComplete = 'off',
  value = '',
  onChange,
  onInput,
  onKeyPress,
  onBlur,
  onClick,
  required,
  disabled,
  minLength,
  maxLength,
  min,
  max,
}) => {
  const inputProps = {
    // className: `input ${className}`,
    type,
    name,
    autoComplete,
    value,
  };

  if (placeholder !== undefined) inputProps.placeholder = placeholder;
  if (required !== undefined) inputProps.required = required;
  if (disabled !== undefined) inputProps.disabled = disabled;
  if (minLength !== undefined) inputProps.minLength = minLength;
  if (maxLength !== undefined) inputProps.maxLength = maxLength;
  if (min !== undefined) inputProps.min = min;
  if (max !== undefined) inputProps.max = max;

  if (onChange !== undefined) inputProps.onChange = e => onChange(e);
  if (onInput !== undefined) inputProps.onInput = e => onInput(e);
  if (onKeyPress !== undefined) inputProps.onKeyPress = e => onKeyPress(e);
  if (onBlur !== undefined) inputProps.onBlur = e => onBlur(e);
  if (onClick !== undefined) inputProps.onClick = e => onClick(e);

  return <input className={`input ${className}`} {...inputProps} />;
};

export default Input;
